import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticSidebarShortcutsResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-sidebar-shortcuts/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { softwareCapacityWorkEmbedRoute } from '@jira/router-routes__software-capacity-routes/src/softwareCapacityWorkEmbedRoute.tsx';
import { CapacityEmbedSkeleton } from '@jira/platform__skeletons/src/ui/capacity/CapacitySkeleton.tsx';
import { capacityWorkRouteEntry } from './common/capacityWorkRouteEntry.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwareCapacityWorkEmbedRouteEntry: Route = createEntry(
	softwareCapacityWorkEmbedRoute,
	() => ({
		group: 'software',
		skeleton: CapacityEmbedSkeleton,
		// eslint-disable-next-line no-restricted-syntax
		component: CapacityEmbedSkeleton,

		entryPoint() {
			if (__SERVER__) {
				return undefined;
			}
			return capacityWorkRouteEntry;
		},

		layout: chromelessLayout,

		resources: [
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			incidentExperimentTraitResource,
			projectContextResource,
			forgeProjectModuleResource,
			staticSidebarShortcutsResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			...jiraSpaResources(),
		],

		ufoName: 'next-gen-capacity-work-embed',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
